var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Portal } from '../../../portal';
import { useReceiptModalContext } from '../../context/ReceiptModalContext';
import { StyledReceiptModalToggle, StyledReceiptModalToggleIcon, StyledReceiptModalToggleLip, StyledReceiptModalToggleWrapper, } from './styles/receipt-modal-toggle.styled';
export const ReceiptModalToggle = (_a) => {
    var { children, dataTest = 'receipt-modal-toggle', ariaLabel } = _a, props = __rest(_a, ["children", "dataTest", "ariaLabel"]);
    const { setIsOpen } = useReceiptModalContext();
    return (_jsx(Portal, { id: "receipt-modal-toggle", cleanup: true, children: _jsxs(StyledReceiptModalToggleWrapper, { "data-test": dataTest, children: [children, _jsx(StyledReceiptModalToggle, Object.assign({ "aria-label": ariaLabel, onClick: () => {
                        setIsOpen(true);
                    } }, props, { children: _jsx(StyledReceiptModalToggleLip, { children: _jsx(StyledReceiptModalToggleIcon, {}) }) }))] }) }));
};
